import React, { useState } from "react";
import {
  Box,
  Typography,InputAdornment,
} from "@mui/material";
import { MONTHS } from "../../../constants/months";
import { validateBudget } from "../../../Utils/validators/campaignSettingsValidators";
import CustomOutlinedInput from "components/CustomOutlinedInput/CustomOutlinedInput";

const monthsPerRow = 6;

const MonthlyBudgetCap = ({
  monthlyBudget,
  setMonthlyBudget,
  targetValue,
  setTargetValue,
  errors,
  dailyBudgetCap,
  currencySymbol
}) => {
    const [validationErrors, setValidationErrors] = useState({});
    const [budgetStatus, setBudgetStatus] = useState(null);
    const handleMonthlyBudgetChange = (month, value, index) => {
        if (/^\d*$/.test(value)) {
            setMonthlyBudget((prev) => ({
                ...prev,
                [`budget_month_${index + 1}`]: value,
            }));
        }
    };

    const currency = currencySymbol;

    const handleBudgetCapBlur = async () => {
        const result = await validateBudget(
          Number(targetValue),
          dailyBudgetCap,
          {
            ...Object.keys(monthlyBudget).reduce((acc, curr, index) => {
              acc[`budget_month_${index + 1}`] =  monthlyBudget[curr] ? Number(monthlyBudget[curr]): null;
              return acc;
            }, {}),
          }
        );
        if(result.success) {
            delete errors.defaultBudget;
        }
        setBudgetStatus(
            result.success
                ? { success: true, error: null }
                : { success: false, error: result.errors['default_budget'] || "Invalid budget cap value" }
        );
    };

    const handleMonthlyBudgetBlur = async (month, index) => {
        console.log(monthlyBudget);
        
        const result = await validateBudget(
          Number(targetValue),
          dailyBudgetCap,
          {
            ...Object.keys(monthlyBudget).reduce((acc, curr, index) => {
              acc[`budget_month_${index + 1}`] = monthlyBudget[curr] ? Number(monthlyBudget[curr]): null;
              return acc;
            }, {}),
          }
        );

        if (result.success) {
            setValidationErrors((prev) => ({ ...prev, [`budget_month_${index + 1}`]: null }));
        } else {
            setValidationErrors((prev) => ({
                ...prev,
                [`budget_month_${index + 1}`]: result.errors[`budget_month_${index + 1}`],
            }));
        }
    };

    const handleTargetValueChange = (event) => {
        const value = event.target.value;
        if (/^\d*$/.test(value)) {
            setTargetValue(value);
        }
    };
    return (
        <Box className="monthlyBudgetCap">
            <Box display="flex" alignItems="flex-start" flexDirection="row">
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                    sx={{ paddingRight: "15px" }}
                >
                    <Typography className="sectionTitle"> Monthly Budget Cap per hotel ({currency})</Typography>
                </Box>
                <Box display="flex" flexDirection="column" alignItems="flex-start" sx={{ paddingLeft: "30x" }}>
                    <Typography className="sectionTitleVariable"> Minimum budget required:{currency}150 </Typography>
                </Box>
            </Box>

            <Box display="flex" alignItems="flex-start" p={2}>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                    sx={{
                        paddingRight: "15px",
                    }}
                >
                    <CustomOutlinedInput
                        inputPaddingLeft={"0px"}
                        placeholder="Enter Monthly Budget Cap"
                        value={targetValue}
                        onChange={handleTargetValueChange}
                        className="no-border-focus"
                        type="number"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*", sx: {maxWidth: "140px"} }}
                        sx={{
                            maxWidth: "140px"
                        }}
                        minWidth="140px"
                        helperText={
                            errors.defaultBudget ?? (budgetStatus
                                ? budgetStatus.error || "Monthly Budget Cap"
                                : "Monthly Budget Cap")
                        }
                        error={errors.defaultBudget || (budgetStatus && budgetStatus.success === false)}
                        success={budgetStatus && budgetStatus.success === true}
                        onBlur={handleBudgetCapBlur}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Typography variant="body2" sx={{ fontSize: "12px", color: "#373F41" }}>
                                        {currency}
                                    </Typography>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                <Box
                    display="grid"
                    gridTemplateColumns={`repeat(${monthsPerRow}, 1fr)`}
                >
                    {MONTHS.map((month, index) => (
                        <Box
                            key={month}
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            sx={{ paddingRight: "16px", marginBottom: "12px" }}
                            className="monthField"
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    display: "flex",
                                    textAlign: "right",
                                    color: "#373F41",
                                    fontSize: "10px",
                                    paddingInline: "5px",
                                    width: '20px'
                                }}
                                className="monthLabel"
                            >
                                {month}
                            </Typography>
                            <CustomOutlinedInput
                                inputPaddingLeft={"5px"}
                                minWidth={"60px"}
                                inputPadding={"0px"}
                                value={monthlyBudget?.[`budget_month_${index + 1}`] || ""}
                                onChange={(e) => handleMonthlyBudgetChange(month, e.target.value, index)}
                                className="no-border-focus monthInput"
                                type="number"
                                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                onBlur={() => handleMonthlyBudgetBlur(month, index)}
                                error={!!validationErrors[`budget_month_${index + 1}`]}
                                helperText={validationErrors[`budget_month_${index + 1}`] || ""}
                                sx={{maxWidth: '60px'}}
                            />
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default MonthlyBudgetCap;
